/**
 * Composition label formatters shared between the canvas action layer
 * (`CompositionCanvasActionsLayer` / `resolveCanvasTarget`) and the
 * quick-edit popover (`CompositionQuickEditPopover`). Kept here rather
 * than in the popover module to avoid a `videoTranscriptionProcessor →
 * components` import inversion when the canvas resolver needs to build
 * a header label without dragging in the popover component.
 */

/**
 * Compute the popover header label from a `TimelineMarker`-shaped object.
 * The transcript-side caller (which already has a marker in hand) and the
 * canvas-side caller (which synthesizes a marker after resolving a canvas
 * selection) both call this so the label format stays in one place.
 */
export function formatHeaderLabelFromMarker(marker: {
  type: 'introCard' | 'endCard' | 'nameCard' | 'overlay';
  label?: string;
}): string {
  switch (marker.type) {
    case 'introCard':
      return marker.label ? `Intro card — ${marker.label}` : 'Intro card';
    case 'endCard':
      return marker.label ? `End card — ${marker.label}` : 'End card';
    case 'nameCard':
      return marker.label ? `Nametag — ${marker.label}` : 'Nametag';
    case 'overlay':
      return marker.label ? `Graphic Overlay — ${marker.label}` : 'Overlay';
  }
}
